import React from "react";
import { formatDateTime } from "../utils/date";

/**
 * ReportHeader — branded report header strip.
 * Shown on every report page; printed at the top of the page when user prints/saves PDF.
 *
 * Uses the FULL-COLOR logo (.asl-logo-report) per the system logo policy.
 */
export default function ReportHeader({ title, filters, dateGenerated, dataTestid = "report-header" }) {
    const today = dateGenerated || formatDateTime();
    return (
        <div className="asl-report-header" data-testid={dataTestid}>
            <img
                src="/asl-logo.png"
                alt="ASL"
                className="asl-logo-report"
                data-testid="report-header-logo"
            />
            <div className="meta">
                <h1>ASL HR Management Platform</h1>
                <div className="sub">
                    Managed by <span className="accent">Kaafi Hire Employment Services Ltd</span>
                </div>
                <div className="chips" data-testid="report-header-chips">
                    <span><span className="lbl">Report:</span>{title}</span>
                    {(filters || []).filter((f) => f && f.value).map((f, i) => (
                        <span key={i}><span className="lbl">{f.label}:</span>{f.value}</span>
                    ))}
                    <span><span className="lbl">Generated:</span>{today}</span>
                </div>
            </div>
        </div>
    );
}
